import { createSelector } from 'reselect'


export const getHome = createSelector(
  [
    state => state.core.home,
  ],
  home => home,
)

export const getAllNodes = createSelector(
  [
    state => state.core.nodes,
  ],
  nodes => nodes,
)

export const getNodeById = createSelector(
  [
    object => object.state.core.nodes,
    object => object.id,
  ],
  (nodes, id) => nodes.find(node => node.id === id),
)

export const getNodesByIds = createSelector(
  [
    object => object.state.core.nodes,
    object => object.ids,
  ],
  (nodes, ids) => {
    if (Array.isArray(ids) && (ids.length > 0)) {
      return ids.map(id => nodes.find(node => node.id === id)).filter(node => node !== undefined)
    }
    return false
  },
)

export const getChildNodesById = createSelector(
  [
    object => object.state,
    object => object.id,
  ],
  (state, id) => {
    const activeNode = state.core.nodes.find(node => node.id === id)
    if ((activeNode !== undefined) && Array.isArray(activeNode.children) && (activeNode.children.length > 0)) {
      return getNodesByIds({
        state,
        ids: activeNode.children,
      })
    }
    return false
  },
)

export const getNextId = createSelector(
  [
    state => state.core.nextNode,
  ],
  nextId => nextId,
)

export const getClash = createSelector(
  [
    state => state.core.clash,
  ],
  clash => clash,
)

export const getTopSteps = createSelector(
  [
    object => object.state,
    object => object.topSteps,
  ],
  (state, topSteps) => topSteps.map(step => (state[step])),
)

export const getCrumbsById = createSelector(
  [
    object => object.state,
    object => object.state.core.nodes,
    object => object.id,
  ],
  (state, nodes, id) => {
    let crumbPath = ''

    const getElements = (nodeId, elements) => {
      const current = nodes.find(node => node.id === nodeId)
      if (current !== undefined) {
        if (('path' in current) && (current.path !== null)) {
          crumbPath = current.path
        }
        if (('parent' in current) && (current.parent !== null)) {
          getElements(current.parent, elements)
        }
      }
      let path
      if (Array.isArray(current.children) && (id !== current.id)) {
        if (current.nodeType === 'Root') {
          path = crumbPath
        } else {
          path = `${crumbPath}/${current.id}`
        }
      }
      elements.push({
        id: current.id,
        title: current.title,
        path,
      })
      return elements
    }

    return getElements(id, [])
  },
)

export const getArea = createSelector(
  [
    state => state.core.area,
  ],
  area => area,
)

export const getLightbox = createSelector(
  [
    state => state.core.lightbox,
  ],
  lightbox => lightbox,
)




// WEBPACK FOOTER //
// ./src/modules/core/selectors.js